var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Crib"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 22C10.85 22 9.74583 21.8083 8.6875 21.425C7.62917 21.0417 6.65 20.5 5.75 19.8C5.51667 19.6167 5.39167 19.3792 5.375 19.0875C5.35833 18.7958 5.45 18.55 5.65 18.35C5.85 18.15 6.0875 18.05 6.3625 18.05C6.6375 18.05 6.89167 18.1417 7.125 18.325C7.25833 18.4417 7.4 18.55 7.55 18.65C7.7 18.75 7.85 18.8417 8 18.925V16H6C5.45 16 4.97917 15.8042 4.5875 15.4125C4.19583 15.0208 4 14.55 4 14V8C4 6.9 4.39167 5.95833 5.175 5.175C5.95833 4.39167 6.9 4 8 4H11C11.2833 4 11.5208 4.09583 11.7125 4.2875C11.9042 4.47917 12 4.71667 12 5V9H18C18.55 9 19.0208 9.19583 19.4125 9.5875C19.8042 9.97917 20 10.45 20 11V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H16V18.925C16.1667 18.825 16.325 18.725 16.475 18.625C16.625 18.525 16.775 18.4167 16.925 18.3C17.1417 18.1167 17.3917 18.0333 17.675 18.05C17.9583 18.0667 18.1917 18.1667 18.375 18.35C18.575 18.55 18.6667 18.7875 18.65 19.0625C18.6333 19.3375 18.5167 19.5667 18.3 19.75C17.4 20.4667 16.4125 21.0208 15.3375 21.4125C14.2625 21.8042 13.15 22 12 22ZM12 20C12.3333 20 12.6667 19.9792 13 19.9375C13.3333 19.8958 13.6667 19.8333 14 19.75V16H10V19.75C10.3333 19.8333 10.6667 19.8958 11 19.9375C11.3333 19.9792 11.6667 20 12 20Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrib);
export default __webpack_public_path__ + "static/media/crib.4b1eb44783f58c609cb2ce643a1aa5e8.svg";
export { ForwardRef as ReactComponent };